{
  "shellSkipMenuMainContent": "Saltar al contenido principal"
}
